// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"Breadcrumb_breadcrumb__rUKQ4","breadcrumb-separator":"Breadcrumb_breadcrumb-separator__pV4Pz"};